import React from 'react';

import { Grid } from '@mui/material';

const TwoPaneMapTableLayout = ({
  mapToolbarComponent,
  mapComponent,
  tableToolbarComponent,
  tableComponent,
  sortComponent,
  showFullMap,
  showFullTable,
}: {
  mapToolbarComponent: React.ReactNode;
  mapComponent: React.ReactNode;
  tableToolbarComponent: React.ReactNode;
  tableComponent: React.ReactNode;
  sortComponent: React.ReactNode;
  showFullMap: boolean;
  showFullTable: boolean;
}) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '100%', ...(showFullTable ? {} : { height: '100vh' }) }}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      {!showFullMap && (
        <Grid container item xs={12} md={showFullTable ? 12 : 6} spacing={1}>
          <Grid container item xs={12}>
            {tableToolbarComponent}
          </Grid>
          <Grid container item xs={12}>
            {sortComponent}
          </Grid>
          <Grid container item xs={12}>
            {tableComponent}
          </Grid>
        </Grid>
      )}
      {!showFullTable && (
        <Grid container item xs={12} md={showFullMap ? 12 : 6} spacing={1}>
          <Grid container item xs={12}>
            {mapToolbarComponent}
          </Grid>
          <Grid container item xs={12}>
            {mapComponent}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default TwoPaneMapTableLayout;
